import { j as a } from "./jsx-runtime-3tyXYecC.mjs";
import { u as n } from "./use-svg-DBlH3_L4.mjs";
import { f as m } from "./format-base-props-8NDUNDcL.mjs";
const i = (s) => {
  const { containerRef: o, name: r, ...t } = s, e = n(`https://staticfe.bamboohr.com/assets/icons/${r}.svg`);
  return /* @__PURE__ */ a.jsx("svg", { ...e, ...m(t), ref: o });
};
export {
  i as B
};
//# sourceMappingURL=base-icon-v2-DZwX3wnO.mjs.map
